import request from '@/utils/request'

let PanalysisApi = {

  /*促销分析列表*/
  list(data) {
    return request._post('/shop/plus.panalysis.Index/index', data);
},
/*添加促销分析*/
add(data) {
    return request._post('/shop/plus.panalysis.Index/add', data);
},
/*修改促销分析*/
edit(data) {
    return request._post('/shop/plus.panalysis.Index/edit', data);
},
/*删除促销分析*/
del(data) {
    return request._post('/shop/plus.panalysis.Index/del', data);
},
fx(data) {
    return request._post('/shop/plus.panalysis.Index/fx', data);
},
/*促销分析详情*/
detail(data) {
  return request._post('/shop/plus.panalysis.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.panalysis.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.panalysis.Setting/getSetting', data, errorback);
    },
}
export default PanalysisApi;



// WEBPACK FOOTER //
// ./src/api/panalysis.js